import React, { ReactNode } from "react";

interface SettingsActionsProps {
  children: ReactNode;
}

const SettingsActions: React.FC<SettingsActionsProps> = ({ children }) => {
  return <div className="settings-page__actions">{children}</div>;
};

export default SettingsActions;


